
import { USER_LOGIN, REGISTER_USER, SUCCESSFULL_REGISTRATION, FIREBASE_CREATE_USER, VALIDATE_REFERRALCODE, GET_LEGAL_AGREEMENT, SAVE_LEGAL_AGREEMENT } from "@/store/actions.type.js";
import { mapActions } from "vuex";
export default {
    data () {
        return {
            name: "",
            isDisabled: false,
            password: null,
            confirmPassword: null,
            email: "",
            country: "+91",
            mobilenumber: "",
            refferal: this.$route.query.referral,
            registerLoading: true,
			next: ''
        };
    },
	created () {
        if (this.$route.query && this.$route.query.next) {
            this.next = this.$route.query.next;
            localStorage.setItem('redirectpath', this.next);
        }
        if (this.$route.query.utm_source) {
            localStorage.setItem('utmParams',window.location.href.split('?').pop());
        }
        if(this.$route.query.utm_source == 'AnandRathi'){
            this.$toastr.Add({
                name: "disclaimer",
                msg: "“Anand Rathi Share & Stock Brokers Ltd does not provide investment advisory or online portfolio evaluation services. If a client is interested in portfolio evaluation services, they can avail of these services through William O’Neil India Pvt. Ltd. Any discrepancies/disputes will remain between a client & William O’Neil India Pvt. Ltd. Anand Rathi Share & Stock Brokers Ltd will not participate or be a party in any dispute.”",
                type: "info", // Toast type,
                position: "toast-top-full-width",
                clickClose: true, // Click Close Disable
                timeout: 0,
                showCloseButton: true,
              });
        }
    },
    computed: {
        isRedirectedBrokerUrl(){
          return (localStorage.getItem('utmParams')==undefined || localStorage.getItem('utmParams')==null
          || localStorage.getItem('utmParams') == 'utm_source=ARGuest' )?false:true;
        },
        isARGuest() {
          return localStorage.getItem('utmParams') == 'utm_source=ARGuest'? true:false;
        }
    },
    methods: {
        ...mapActions({
            registeruser: REGISTER_USER,
            postregistration: SUCCESSFULL_REGISTRATION,
            firebasecreateuser: FIREBASE_CREATE_USER,
            validatereferralcode: VALIDATE_REFERRALCODE,
            getactivelegal: GET_LEGAL_AGREEMENT,
			savelegalagreement: SAVE_LEGAL_AGREEMENT,
          usersignin: USER_LOGIN,
        }),

        validateUserRegistration () {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.isDisabled = true
                    this.registerUser();
                }
            });


        },
        async callUserRegister (regObj) {
            var self = this;
            await this.registeruser(regObj).then(async (result) =>  {
              if(result.data.response.success && result.data.response.isARrathiUserUpdate) {
                var userObj = { email: regObj.email, password:  regObj.password}
                 await this.usersignin(userObj).then(data => {
                  if (data.response.success) {
                    self.$router.replace('/evaluation/');
                  }})
                // window.location.href = 'http://localhost:8080/#/home?utm_source=AnandRathi&utm_client_code=hoola123'
              } else {
                if (result.data.response.success && result.data.response.token != "") {
                  this.postregistration(result.data.response).then(data => {
                    this.firebasecreateuser(regObj).then(success => {
                      if (success) {
                        this.$notify({
                          group: 'allAlerts',
                          title: '',
                          type: 'success',
                          text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-success fa fa-check-circle" aria-hidden="true"></i></span> <span class="notificationText">Registered SuccessFully </span></div>'
                        });
                        window.localStorage.setItem('signupMethod', 'PortfolioSmith')
                        this.getActiveLegalAgreement('psi', window.localStorage.getItem('uid'))
                        if (localStorage.getItem('redirectpath')) {
                          this.$router.replace(this.$route.query.redirect || localStorage.getItem('redirectpath'));
                          localStorage.removeItem("redirectpath");
                        } else {
                          localStorage.setItem('callRiskProfiler', true);
                          self.$router.replace(this.$route.query.redirect || '/plandetails/');
                        }
                      } else {
                        this.$notify({
                          group: 'allAlerts',
                          title: '',
                          type: 'error',
                          text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText">User Registration Failed, Pelase try again! </span></div>'
                        });
                      }
                    });
                  });
                } else {
                  this.$notify({
                    group: 'allAlerts',
                    title: '',
                    type: 'error',
                    text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText">' + result.data.response.message + '</span></div>'
                  });
                }
              }
                this.isDisabled = false;
            });
        },

        async registerUser () {
            this.registerLoading = false;

            var self = this;
            var mobileNumber = this.country + this.mobilenumber
            var regObj = { "name": this.name, "email": this.email, "password":(this.isRedirectedBrokerUrl==true && localStorage.getItem('utmParams').split('utm_source=AnandRathi&utm_client_code=')[1].length>0)?localStorage.getItem('utmParams').split('utm_source=AnandRathi&utm_client_code=')[1].toLocaleLowerCase(): this.password, "phoneNumber": mobileNumber, "referralCode": this.refferal, "deviceId": 1, "providerId": 1 ,"utmParams":localStorage.getItem('utmParams') }
            var referralCodeObj = {};
            referralCodeObj.referralCode = this.refferal;
            if (this.refferal != null && this.refferal != '') {
                await this.validatereferralcode(referralCodeObj).then(result => {
                    if (result.data.response.success) {
                        self.callUserRegister(regObj);
                    }
                    else {
                        this.isDisabled = false;
                        self.$notify({
                            group: 'allAlerts',
                            title: '',
                            type: 'error',
                            text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText">Invalid Referral Code! </span></div>'
                        });
                    }
                });
            }
            else {
                self.callUserRegister(regObj);
            }
            this.registerLoading = true;
        },

        async getActiveLegalAgreement(productCode,userId) {
            var payload = {
                userId:userId,
                productCode: productCode
            };
            await this.getactivelegal(payload).then(result => {
                if(result!=null){
                    this.saveLegalAgreement(userId, result.id)
                }

            });
        },

        async saveLegalAgreement(userId, legalAgreementId) {
            var self = this;
            var payload = {
                userId:userId,
                legalAgreementId:legalAgreementId,
                isAccepted:1
            };
            await this.savelegalagreement(payload).then(result => {
                if(result!=null){
                    // if (result.success ==  1) {
                    //     self.isShowAcceptButton = false
                    // }
                }
            });
        },
    }
};



// WEBPACK FOOTER //
// ./src/assets/js/register.js